import { useState } from 'react';
import { Box, Flex } from '@chakra-ui/react';

import { TextBold, TextRegular } from 'UiKit/typography';
import ButtonOutline from 'UiKit/button/buttonOutline';
import ButtonSolid from 'UiKit/button/buttonSolid';
import { PlusIcon } from 'Asset/icon';
import { Condition, Iteration } from 'Component/others';

import { useTalkingPointUpsertState } from 'View/brief-live/state/talkingPointState';

import ProductItem from './product-item';
import ProductCreatePanel from './product-create-panel';

import styles from './styles.module.css';

const ProductHighlightCard = ({ brand, onChange, products, onDelete, onEdit, t }) => {
  const [isCreating, setIsCreating] = useState(false);
  const { updateState, updateFilterState } = useTalkingPointUpsertState();

  const handleCreateManualProduct = (product) => {
    onChange(product);
    setIsCreating(false);
  };

  return (
    <Box className={styles['card__container']}>
      <Box className={styles['card__header']}>
        <TextBold className={styles['card__label']}>{t('formTalkingPoint.productHighlight')}</TextBold>
        <TextRegular className={styles['card__description']}>{t('formTalkingPoint.productHighlightDescription')}</TextRegular>
      </Box>

      <Condition statement={products?.length > 0 || isCreating}>
        <Box className={styles['card__product-list']}>
          <Iteration items={products} render={(product) => <ProductItem key={product?.id} product={product} onDelete={onDelete} onEdit={onEdit} t={t} />} />
        </Box>
      </Condition>

      <Condition statement={isCreating}>
        <ProductCreatePanel onSave={handleCreateManualProduct} onCancel={() => setIsCreating(false)} />
        <Condition statement={products?.length > 0}>
          <Box className={styles['card__product-separator']}></Box>
        </Condition>
      </Condition>

      <Flex gap="20px">
        <ButtonSolid
          className={styles['add-product__button']}
          type="button"
          onClick={() => {
            updateState({ isOpenModalSelectProduct: true });
            updateFilterState({ brand });
          }}
          disabled={!brand}
        >
          <PlusIcon size={14} /> {t('selectProductModal.addProduct')}
        </ButtonSolid>
        <ButtonOutline className={styles['add-manual-product__button']} type="button" onClick={() => setIsCreating(true)} disabled={!brand}>
          <PlusIcon size={14} /> {t('selectProductModal.addManualProduct')}
        </ButtonOutline>
      </Flex>
    </Box>
  );
};

export default ProductHighlightCard;
